import { Box } from '@material-ui/core';
import maiaLogo from '_assets/common/maia-logo.png';
import useStyles from './styles';

export default function MaiaLogo() {
  const classes = useStyles();
  return (
    <Box>
      <img src={maiaLogo} alt="Maia logo" className={classes.icon} />
    </Box>
  );
}
